import * as React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../forms/button"

const CustomModal = (props) => {
    return (
        <Modal show={props.isShow} onHide={props.handlerClose} size={props.size ? props.size : "sm"} dialogClassName={props.isMobile && "modal-mobile-width"}>
            <Modal.Header closeButton={!props.hideCloseButton} className="align-items-center">
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={props.isMobile ? { paddingLeft: 0, paddingRight: 0, paddingBottom: 0 } : {}}>
                {props.children}
            </Modal.Body>
            <Modal.Footer style={props.handlerSaveChange != undefined || props.handlerCancel !=undefined ? {} : {display:"contents"}}>
                {props.handlerSaveChange && <Button disabled={props.disabledButtonSaveChange ? true : false} color={props.saveButtonColor != null ? props.saveButtonColor: "Primary"} onClick={props.handlerSaveChange.bind(this)} label={props.saveChangeLabel} />}
                {props.handlerCancel && <Button color={props.cancelButtonColor != null ? props.cancelButtonColor: "Secondary"} onClick={props.handlerCancel.bind(this)} label={props.cancelLabel} />}
            </Modal.Footer> 
           
        </Modal>
    );
}

export default CustomModal;


// WEBPACK FOOTER //
// ./components/common/modal/modal.jsx